// src/pages/ForgotPassword.jsx
import React, { useState } from "react";
import axios from "../services/api";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setMsg("");
    setErr("");
    setLoading(true);
    try {
      await axios.post("/api/auth/forgot-password", { email });
      setMsg("If that email exists, a reset link has been sent.");
    } catch {
      setErr("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="mx-auto max-w-lg">
        <section className="card p-6 md:p-8">
          <header className="mb-6 text-center">
            <h1 className="font-display text-3xl md:text-4xl">
              Reset your <span className="bg-gradient-to-r from-brand-500 to-glow bg-clip-text text-transparent">password</span>
            </h1>
            <p className="mt-2 text-slate-300">
              We’ll email you a link to create a new password.
            </p>
          </header>

          {msg && (
            <div
              className="mb-4 rounded-xl border border-green-400/20 bg-green-500/10 p-3 text-sm text-green-200"
              aria-live="polite"
            >
              {msg}
            </div>
          )}
          {err && (
            <div
              className="mb-4 rounded-xl border border-red-500/20 bg-red-500/10 p-3 text-sm text-red-200"
              aria-live="assertive"
            >
              {err}
            </div>
          )}

          <form onSubmit={submit} className="space-y-4">
            <div className="field">
              <label htmlFor="email" className="label">Email</label>
              <input
                id="email"
                type="email"
                className="input"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
              <p className="help">Check your spam folder if you don’t see the email.</p>
            </div>

            <button className="btn-primary w-full" disabled={loading} type="submit">
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>

          <div className="mt-6 flex items-center justify-between text-sm text-slate-300">
            <Link to="/login" className="underline">Back to login</Link>
            <span>
              New here? <Link to="/register" className="text-slate-200 underline">Create an account</Link>
            </span>
          </div>
        </section>
      </div>
    </div>
  );
}
